export default __webpack_public_path__ + "a1fcbf58ddf8d990f1539f0d3dfac1c1.jpg";